<template>
<div class="chapter">
<div class="inner_page">
<h2>DEDICATION</h2>
<p class="center top1"><i>To America’s wild horses on who’s backs this country was built, wars were won, and heroes were made. We are forever in your debt.</i></p>
<p class="center"><i>&amp;</i></p>
<p class="center"><i>To you, the wild at heart, kept in cages; may you find your wings.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p3.vue?ad1723b2